// Ported verbatim from the mobile app's src/utils/leveling.js (pure JS).

export function getXpToNextLevel(xp) {
  const level = getLevelFromXP(xp);
  if (level >= levelThresholds.length - 1) {
    return 0;
  }
  return levelThresholds[level + 1] - xp;
}

export function getLevelFromXP(xp) {
  let level = 1;
  for (let i = 1; i < levelThresholds.length; i++) {
    if (xp >= levelThresholds[i]) {
      level = i;
    } else {
      break;
    }
  }
  return level;
}

export function getXPProgress(xp) {
  const level = getLevelFromXP(xp);
  const currentThreshold = levelThresholds[level];
  const nextThreshold =
    level >= levelThresholds.length - 1
      ? levelThresholds[level]
      : levelThresholds[level + 1];

  const xpInCurrentLevel = xp - currentThreshold;
  const xpNeededForNextLevel = nextThreshold - currentThreshold;

  const xpProgress =
    xpNeededForNextLevel > 0
      ? (xpInCurrentLevel / xpNeededForNextLevel) * 100
      : 100;

  return {
    progress: xpProgress,
    level,
    xpInCurrentLevel,
    xpNeededForNextLevel,
    currentThreshold,
    nextThreshold,
  };
}

const levelThresholds = [
  0, 0, 5, 10, 25, 50, 100, 200, 500, 1000, 2000, 3000, 5000, 7000, 10000,
  20000, 40000, 60000, 100000, 250000, 500000, 1000000, 2000000, 4000000,
  8000000, 15000000, 30000000, 60000000, 100000000, 200000000, 500000000,
];

export const levelTitles = {
  1: "يديد بالسالفة",
  2: "مبتدئ",
  3: "توه متعلم",
  4: "نشيط",
  5: "مشارك",
  6: "عضو قديم",
  7: "متمرس",
  8: "خبير",
  9: "محترف",
  10: "متمكن",
  11: "راعي المجال",
  12: "مبدع",
  13: "فاهم السالفة",
  14: "صاحب خبرة",
  15: "معلم",
  16: "فطحل",
  17: "شايب بالسالفة",
  18: "معروف",
  19: "أسطورة",
  20: "ما ينلعب وياه",
  21: "فوق الخيال",
  22: "مرعب",
  23: "حكاية",
  24: "ماكو مثله",
  25: "الوحيد بفنه",
  26: "سيد اللعبة",
  27: "مهيب",
  28: "مو من هالعالم",
  29: "أسطورة الأساطير",
  30: "نهاية اللعبة",
};
